export const firebaseConfig = {
  apiKey: "AIzaSyDQueHkqpieo9s3uIhWMS24ckySQQG48p0",
  authDomain: "falcon-document-solutions.firebaseapp.com",
  projectId: "falcon-document-solutions",
  storageBucket: "falcon-document-solutions.appspot.com",
  messagingSenderId: "206509704007",
  appId: "1:206509704007:web:c94422f94aa1ca721b0262"
};